import React from "react";

const Progress = () => {
  return (
    <div>
      <div class="container flex flex-col px-6 py-10 mx-auto space-y-6 lg:h-[32rem] lg:py-10F lg:flex-row lg:items-center">
        <div class="w-full lg:w-1/2">
        <h1 className="text-xl font-bold text-center title">Front-End</h1>
          <div class="lg:max-w-lg"data-aos="flip-up" data-aos-duration="2000">
            <div class="text-base font-medium dark:text-white">HTML</div>
            <div class="w-full bg-gray-200 rounded-full h-4 mb-4 dark:bg-gray-700">
              <div
                class="bg-cyan-400 text-md mt-2 font-medium text-black text-center leading-none rounded-full"
                style={{ width: "95%" }}
              >
                {" "}
                95%
              </div>
            </div>
            <div class="text-base font-medium dark:text-white">CSS</div>
            <div class="w-full bg-gray-200 rounded-full h-4 mb-4 dark:bg-gray-700">
              <div
                class="bg-cyan-400 mt-2 text-md font-medium text-black text-center leading-none rounded-full"
                style={{ width: "95%" }}
              >
                {" "}
                95%
              </div>
            </div>
            <div class=" text-base font-medium dark:text-white">JAVA-SCRIPT</div>
            <div class="w-full bg-gray-200 rounded-full h-4 mb-4 dark:bg-gray-700">
              <div
                class="bg-cyan-400 mt-2 text-md font-medium text-black text-center leading-none rounded-full"
                style={{ width: "90%" }}
              >
                {" "}
                90%
              </div>
            </div>
            <div class=" text-base font-medium dark:text-white">ECMA SCRIPT-6</div>
            <div class="w-full bg-gray-200 rounded-full h-4 mb-4 dark:bg-gray-700">
              <div
                class="bg-cyan-400 mt-2 text-md font-medium text-black text-center leading-none rounded-full"
                style={{ width: "85%" }}
              >
                {" "}
                85%
              </div>
            </div>
            <div class="text-base font-medium dark:text-white">REACT</div>
            <div class="w-full bg-gray-200 rounded-full h-5 mb-4 dark:bg-gray-700">
              <div
                class="bg-cyan-400 mt-2 text-md font-medium text-black text-center leading-none rounded-full"
                style={{ width: "95%" }}
              >
                {" "}
                95%
              </div>
            </div>
            <div class="text-base font-medium dark:text-white">Tailwind</div>
            <div class="w-full bg-gray-200 rounded-full h-5 mb-4 dark:bg-gray-700">
              <div
                class="bg-cyan-400 mt-2 text-md font-medium text-black text-center leading-none rounded-full"
                style={{ width: "95%" }}
              >
                {" "}
                100%
              </div>
            </div>
            <div class="text-base font-medium dark:text-white">Bootstrap 5</div>
            <div class="w-full bg-gray-200 rounded-full h-5 mb-4 dark:bg-gray-700">
              <div
                class="bg-cyan-400 mt-2 text-md font-medium text-black text-center leading-none rounded-full"
                style={{ width: "95%" }}
              >
                {" "}
                100%
              </div>
            </div>
            <div class="text-base font-medium dark:text-white">Material Ui</div>
            <div class="w-full bg-gray-200 rounded-full h-5 mb-4 dark:bg-gray-700">
              <div
                class="bg-cyan-400 mt-2 text-md font-medium text-black text-center leading-none rounded-full"
                style={{ width: "95%" }}
              >
                {" "}
                95%
              </div>
            </div>
          </div>
        </div>

        <div class=" w-full lg:w-1/2"data-aos="flip-up" data-aos-duration="2000">
        <h1 className="text-xl font-bold text-center title -mt-8">Back-End</h1>
            <div class="lg:max-w-lg">
            <div class="text-base font-medium dark:text-white">NODE JS</div>
            <div class="w-full bg-gray-200 rounded-full h-4 mb-4 dark:bg-gray-700">
              <div
                class="bg-cyan-400 mt-2 text-md font-medium text-black text-center leading-none rounded-full"
                style={{ width: "90%" }}
              >
                {" "}
                90%
              </div>
            </div>
            <div class="text-base font-medium dark:text-white">MONGODB</div>
            <div class="w-full bg-gray-200 rounded-full h-4 mb-4 dark:bg-gray-700">
              <div
                class="bg-cyan-400 mt-2 text-md font-medium text-black text-center leading-none rounded-full"
                style={{ width: "90%" }}
              >
                {" "}
                90%
              </div>
            </div>
            <div class=" text-base font-medium dark:text-white">EXPRESS JS</div>
            <div class="w-full bg-gray-200 rounded-full h-4 mb-4 dark:bg-gray-700">
              <div
                class="bg-cyan-400 mt-2 text-md font-medium text-black text-center leading-none rounded-full"
                style={{ width: "95%" }}
              >
                {" "}
                95%
              </div>
            </div>
            <div class="text-base font-medium dark:text-white">REDUX</div>
            <div class="w-full bg-gray-200 rounded-full h-4 mb-4 dark:bg-gray-700">
              <div
                class="bg-cyan-400 mt-2 text-md font-medium text-black text-center leading-none rounded-full"
                style={{ width: "90%" }}
              >
                {" "}
                90%
              </div>
            </div>
            <div class="text-base font-medium dark:text-white">FIREBASE</div>
            <div class="w-full bg-gray-200 rounded-full h-4 mb-4 dark:bg-gray-700">
              <div
                class="bg-cyan-400 mt-2 text-md font-medium text-black text-center leading-none rounded-full"
                style={{ width: "90%" }}
              >
                {" "}
                90%
              </div>
            </div>
            <div class="text-base font-medium dark:text-white">Mongoose</div>
            <div class="w-full bg-gray-200 rounded-full h-4 mb-4 dark:bg-gray-700">
              <div
                class="bg-cyan-400 mt-2 text-md font-medium text-black text-center leading-none rounded-full"
                style={{ width: "90%" }}
              >
                {" "}
                90%
              </div>
            </div>
            <div class="text-base font-medium dark:text-white">Github</div>
            <div class="w-full bg-gray-200 rounded-full h-4 mb-4 dark:bg-gray-700">
              <div
                class="bg-cyan-400 mt-2 text-md font-medium text-black text-center leading-none rounded-full"
                style={{ width: "90%" }}
              >
                {" "}
                90%
              </div>
            </div>
            <div class="text-base font-medium dark:text-white">Netlify Hosting</div>
            <div class="w-full bg-gray-200 rounded-full h-4 mb-4 dark:bg-gray-700">
              <div
                class="bg-cyan-400 mt-2 text-md font-medium text-black text-center leading-none rounded-full"
                style={{ width: "90%" }}
              >
                {" "}
                90%
              </div>
            </div>
            </div>
           
        </div>
      </div>
    </div>
  );
};

export default Progress;
